import React from "react";
import { Form } from "react-bootstrap";
import { IoIosArrowBack } from "react-icons/io";
import styles from "./index.module.scss";
import { useNavigate } from "react-router-dom";

// ShadowContainer
export const ShadowContainer: React.FC = () => {
  return <div className={styles.ShadowContainer}></div>;
};

// BackButton
interface BackButtonProps {
  text?: string | React.ReactElement;
  isRelative?: boolean;
  classes?: string;
  // handleBackButton?: () => void;
}

export const BackButton: React.FC<BackButtonProps> = ({
  text = "",
  classes = "",
  isRelative = false,
  // handleBackButton = () => { },
}) => {
  const navigate = useNavigate();

  return (
    <div
      className={`${styles.BackButton} ${isRelative ? styles.relative : ""
        } ${classes}`}
      onClick={() => navigate(-1)}
    >
      <span className={styles.icon}>
        <IoIosArrowBack />
      </span>
      {text ? <span>{text}</span> : ""}
    </div>
  );
};

// Input
interface InputProps {
  type?: string;
  classes?: string;
  style?: React.CSSProperties;
  size?: "lg" | "sm";
  placeholder?: string;
  value?: string;
  as?: React.ElementType;
  name?: string;
  rows?: number;
  checked?: boolean;
  readOnly?: boolean;
  disable?: boolean;
  outlined?: boolean;
  onChange?: React.ChangeEventHandler<HTMLInputElement | HTMLTextAreaElement>;
  onClick?: React.MouseEventHandler;
}

export const Input: React.FC<InputProps> = ({
  type = "text",
  classes = "mt-1 mb-2",
  style = {},
  size = "lg",
  placeholder = "",
  value = "",
  disable = false,
  outlined = false,
  as = "input",
  name = "",
  rows = 1,
  checked = false,
  readOnly = false,
  onChange = () => { },
  onClick = () => { },
}) => {
  return (
    <Form.Control
      name={name}
      size={size}
      readOnly={readOnly}
      checked={checked}
      className={`${styles.Input} ${outlined ? styles.outlined : ""
        } ${classes}`}
      placeholder={placeholder}
      type={type}
      value={value}
      as={as}
      rows={rows}
      disabled={disable}
      onChange={onChange}
      onClick={onClick}
      style={style}
    />
  );
};

// CustomInput
interface CustomInputProps {
  name?: string;
  placeholder?: string;
  classes?: string;
  type?: string;
  autoFocus?: boolean;
  onChange?: React.ChangeEventHandler<HTMLInputElement>;
}

export const CustomInput: React.FC<CustomInputProps> = ({
  name = "",
  placeholder = "",
  classes = "mt-1 mb-2",
  type = "",
  autoFocus = false,
  onChange,
}) => {
  return (
    <Form.Control
      name={name}
      className={`${styles.Input} ${classes}`}
      placeholder={placeholder}
      autoFocus={autoFocus}
      onChange={onChange}
      type={type}
    />
  );
};

// Title Components
interface TypoProps {
  text?: string | React.ReactElement;
  classes?: string;
}
export const Header: React.FC<TypoProps> = ({ text = "", classes = "" }) => {
  return <h1 className={`${styles.Header} ${classes}`}>{text}</h1>;
};

export const MasterHeader: React.FC<TypoProps> = ({
  text = "",
  classes = "",
}) => {
  return <h2 className={`${styles.MasterHeader} ${classes}`}>{text}</h2>;
};

export const Title: React.FC<TypoProps> = ({ text = "", classes = "" }) => {
  return <h2 className={`${styles.Title} ${classes}`}>{text}</h2>;
};

export const SubHeader: React.FC<TypoProps> = ({ text = "", classes = "" }) => {
  return <h3 className={`${styles.SubHeader} ${classes}`}>{text}</h3>;
};

export const SubTitle: React.FC<TypoProps> = ({ text = "", classes = "" }) => {
  return <h3 className={`${styles.SubTitle} ${classes}`}>{text}</h3>;
};

export const LabelHeader: React.FC<TypoProps> = ({
  text = "",
  classes = "",
}) => {
  return <h5 className={`${styles.LabelHeader} ${classes}`}>{text}</h5>;
};

export const LabelSubHeader: React.FC<TypoProps> = ({
  text = "",
  classes = "",
}) => {
  return <h5 className={`${styles.LabelSubHeader} ${classes}`}>{text}</h5>;
};

export const CardTitle: React.FC<TypoProps> = ({ text = "", classes = "" }) => {
  return <h6 className={`${styles.CardTitle} ${classes}`}>{text}</h6>;
};

export const CardMatchTitle: React.FC<TypoProps> = ({
  text = "",
  classes = "",
}) => {
  return (
    <h6 className={`${styles.CardMatchTitle} ${classes} mt-1 mb-1`}>{text}</h6>
  );
};

// Description
interface DescriptionProps {
  text?: string | React.ReactElement;
  classes?: string;
  onClick?: React.MouseEventHandler<HTMLParagraphElement>;
}

export const Description: React.FC<DescriptionProps> = ({
  text = "",
  classes = "",
  onClick = () => { },
}) => {
  return (
    <p className={`${styles.Description} ${classes}`} onClick={onClick}>
      {text}
    </p>
  );
};

export const DescriptionLight: React.FC<DescriptionProps> = ({
  text = "",
  classes = "",
  onClick = () => { },
}) => {
  return (
    <p className={`${styles.DescriptionLight} ${classes}`} onClick={onClick}>
      {text}
    </p>
  );
};

export const SubDescription: React.FC<DescriptionProps> = ({
  text = "",
  classes = "",
  onClick = () => { },
}) => {
  return (
    <p className={`${styles.SubDescription} ${classes}`} onClick={onClick}>
      {text}
    </p>
  );
};

export const SubDescriptionLight: React.FC<DescriptionProps> = ({
  text = "",
  classes = "",
  onClick = () => { },
}) => {
  return (
    <p className={`${styles.SubDescriptionLight} ${classes}`} onClick={onClick}>
      {text}
    </p>
  );
};

// CardDescription
export const CardDescription: React.FC<DescriptionProps> = ({
  text = "",
  classes = "",
}) => {
  return <p className={`${styles.Description} ${classes} fs-10`}>{text}</p>;
};

// Button
interface ButtonProps {
  text?: string | React.ReactElement;
  classes?: string;
  style?: React.CSSProperties;
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
  disabled?: boolean;
  type?: "button" | "submit" | "reset";
  className?: string;
  isOutlined?: boolean;
}

export const Button: React.FC<ButtonProps> = ({
  text = "",
  classes = "",
  style = {},
  onClick = () => { },
  disabled = false,
  type = "button",
  className = "",
  isOutlined = false,
}) => {
  return (
    <button
      className={`${styles.Button} ${classes} ${className} ${isOutlined ? styles.outlined : ""
        }`}
      style={style}
      onClick={onClick}
      disabled={disabled}
      type={type}
    >
      {text}
    </button>
  );
};

// TextDivider
export const TextDivider: React.FC<TypoProps> = ({
  text = "",
  classes = "",
}) => {
  return <div className={`${styles.TextDivider} ${classes}`}>{text}</div>;
};

// UnorderedList
interface UnorderedListProps {
  lists: string[];
  classes?: string;
  item_classes?: string;
}

export const UnorderedList: React.FC<UnorderedListProps> = ({
  lists = [],
  classes = "",
  item_classes = "",
}) => {
  return (
    <ul className={`${styles.UL} ${classes} fs-7`}>
      {lists.map((item, index) => (
        <li key={index} className={`${item_classes} mt-2 mb-2 fs-7`}>
          {item}
        </li>
      ))}
    </ul>
  );
};

// Checkbox
interface CheckboxProps {
  label?: string;
  classes?: string;
}

export const Checkbox: React.FC<CheckboxProps> = ({
  label = "",
  classes = "",
}) => {
  return (
    <Form.Check
      type="checkbox"
      className={`${styles.Checkbox} ${classes}`}
      label={label}
    />
  );
};

// InputOTP
// interface InputOTPProps {
//   props: React.InputHTMLAttributes<HTMLInputElement>;

// }

// export const InputOTP: React.FC<InputOTPProps> = ({ props }) => {
//   return (
//     <Form.Control
//       {...props}
//       type="text"
//       className={`${styles.Input} ${styles.InputOTP}`}
//       size="lg"
//     />
//   );
// };

// LiveBadge
export const LiveBadge: React.FC<TypoProps> = ({
  text = "Live",
  classes = "",
}) => {
  return <span className={`${styles.LiveBadge} ${classes}`}>{text}</span>;
};

// Score
export const Score: React.FC<TypoProps> = ({ text = "", classes = "" }) => {
  return <span className={`${styles.Score} ${classes}`}>{text}</span>;
};

// CustomSelect
interface CustomSelectProps {
  name?: string;
  title?: string;
  options: { value: string; label: string }[];
  placeholder?: string;
  classes?: string;
  autoFocus?: boolean;
  onChange?: React.ChangeEventHandler<HTMLSelectElement>;
}

export const CustomSelect: React.FC<CustomSelectProps> = ({
  name = "",
  title = "",
  options = [],
  placeholder = "",
  classes = "mt-1 mb-2",
  autoFocus = false,
  onChange,
}) => {
  return (
    <Form.Select
      name={name}
      title={title || placeholder}
      className={`${styles.Select} ${classes}`}
      aria-label={title || placeholder}
      autoFocus={autoFocus}
      onChange={onChange}
    >
      <option value="">{placeholder}</option>
      {options.map((option) => (
        <option key={option.value} value={option.value}>
          {option.label}
        </option>
      ))}
    </Form.Select>
  );
};
